import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Edit from '@material-ui/icons/Edit'
import PriorityHigh from '@material-ui/icons/PriorityHigh'
import CheckBox from '@material-ui/icons/CheckBox'

export default class AllFinancials extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Tickets_Financials._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
	}

	render() {
		const {data, pages, limit, loading,} = this.state;

		const columns = [
			{
				Header: "Ticket Number",
				id: "ticket",
				accessor: obj => (obj.ticket),
				Cell: (props) => {
					let {original} = props;
					let {ticket} = original;
					return (
						<span>
								<Link to={`/tickets/${ticket}`}>
									{ticket}
								</Link>
							</span>
					);
				}
			},
			{
				Header: "Date",
				id: 'created',
				/** @param {Tickets_Financials_Object} obj */
				accessor: obj => obj.created ? moment(obj.created).local().format('MM/DD/YYYY h:mm A') : '',
			},

			{
				Header: "Customer",
				id: 'tickets.customers.name',
				/** @param {Tickets_Financials_Object} obj */
				accessor: obj => obj.tickets.customers.name,
			},
			{
				Header: "Payment Type",
				id: 'tickets_financials_types.name',
				/** @param {Tickets_Financials_Object} obj */
				accessor: obj => obj.tickets_financials_types?.name,
			},
			{
				Header: "Expected Labor Amount",
				id: 'expected_labor',
				/** @param {Tickets_Financials_Object} obj */
				accessor: obj => obj.expected_labor,
			},
			{
				Header: "Labor Amount",
				id: 'labor_amount',
				/** @param {Tickets_Financials_Object} obj */
				accessor: obj => obj.labor_amount,
			},
			{
				Header: "Anti Virus Sales",
				id: 'virus_sales',
				/** @param {Tickets_Financials_Object} obj */
				accessor: obj => obj.virus_sales,
			},
			{
				Header: "Parts Amount",
				id: 'parts_amount',
				/** @param {Tickets_Financials_Object} obj */
				accessor: obj => obj.parts_amount,
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				Cell: props => {
					return (
						<span>
							{props.original.approved === false ?
								<Button id={props.original.pkey} ticket={props.original.ticket} color="secondary" size={"sm"} block={true} onClick={this.approve}>
									<PriorityHigh fontSize='small'/></Button>
								:	<Link to={"/financial/" + props.original.pkey}> <Button color="primary" size={"sm"} block={true}> <CheckBox fontSize={'small'}/></Button></Link>
							}
						</span>
					);
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				Cell: props => {
					return (
						<span>
							<Link to={"/financial/" + props.original.ticket}>
								<Button color="green-meadow" size={"sm"} block={true}>
									<Edit fontSize={'small'}/></Button>
							</Link>
						</span>
					);
				}
			},

		]

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Financials')}
							{this.renderHeaderRight(
								'Financials',
								columns,
							)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}

						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
